import apiClient from "../../../../http-common"

//--------------------Get All Pass Type list--------------------
export const getAllVehicleTypeList = async (listObject) => {
    return await apiClient.post(`/master/vehicleType/list`, listObject, {
        // headers:authHeader()
    });
};



// searchString
export const vehicleTypeBySearchString = async (searchString) => {
    return await apiClient.get(`/master/vehicleType/${searchString}`, {
        // headers:authHeader()
    });
};



// //Delete Record By ID

export const deleteVehicleTypeById = async (id) => {
    return await apiClient.delete(`/master/vehicleType/delete/${id}`, {
        // headers:authHeader()
    });
};

//Save
export const saveVehicleType = async (finalData) => {
    return await apiClient.post(`/master/vehicleType/save`, finalData, {
        // headers:authHeader()
    });
};

//update 
export const updateVehicleType = async (finalData) => {
    return await apiClient.post(`/master/vehicleType/update`, finalData, {
        // headers:authHeader()
    });
};


// dropdown
export const vehicleTypeDropdown = async () => {
    return await apiClient.get(`/master/vehicleType/dropDown`, {
        // headers:authHeader()
    });
}; 